import { render } from "./TherapistManagement.vue?vue&type=template&id=6818471b&scoped=true"
import script from "./TherapistManagement.vue?vue&type=script&lang=js"
export * from "./TherapistManagement.vue?vue&type=script&lang=js"

import "./TherapistManagement.vue?vue&type=style&index=0&id=6818471b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6818471b"]])

export default __exports__